import contentStyles from "../../styles/content.css?url";
import homeStyles from "../../styles/home.css?url";
import shopStyles from "../../styles/shop.css?url";
import type { NativeHome } from "../../server/home.server";

/** The stylesheets a native Home draws: its own, and the post and shop styles its sections use. */
export function homeStylesheets(home: NativeHome) {
  const sections = home.composition === "sections" ? home.sections : [];
  return [
    homeStyles,
    ...(sections.some((section) => section.type === "grid") ? [contentStyles] : []),
    ...(sections.some((section) => section.type === "shop") ? [shopStyles] : []),
  ];
}
